import '../stylesheets/event_autocomplete_search';
import "@fortawesome/fontawesome-free/css/all.css";

import { createApp } from 'vue';
import Autocomplete from '../components/autocomplete.vue';
import { EventAutocompleteSearchComponent } from './event_autocomplete_search_component';

document.addEventListener('DOMContentLoaded', () => {
  const element = document.getElementById('event_autocomplete_search_modal_app');

  if (!element) return;

  const app = createApp({
    components: {
      Autocomplete
    },

    ...EventAutocompleteSearchComponent
  });
  app.mount(element);

  const modalEl = document.getElementById('find-race-modal');
  if (!modalEl) return;

  // Query through the modal, not `element`: Vue replaces the element it
  // mounts on with its own rendered DOM, so the `element` reference above is
  // a detached node once the app is up (and the raw markup has no <input>
  // anyway — the autocomplete component renders it). The modal is an ancestor
  // Vue never touches, so querying it at event time always finds the live input.
  const searchInput = () => modalEl.querySelector('input');

  // When Bootstrap finishes opening the modal it focuses the modal container
  // itself; redirect that focus to the search input so users can type right
  // away. Native focus events are used (instead of jQuery's shown.bs.modal)
  // because each pack has its own jQuery instance, so this pack cannot listen
  // on the instance Bootstrap runs on.
  modalEl.addEventListener('focusin', (event) => {
    if (event.target === modalEl) {
      const input = searchInput();
      if (input) input.focus();
    }
  });

  // Clear the query when the modal closes (X, backdrop click, or ESC all
  // remove the `show` class) so it reopens empty instead of showing stale
  // text and results. Setting input.value alone only updates the DOM;
  // the autocomplete component keeps its own reactive value and restores the
  // old text on the next render, so dispatch a native input event to sync it.
  const observer = new MutationObserver(() => {
    if (!modalEl.classList.contains('show')) {
      const input = searchInput();
      if (input) {
        input.value = '';
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }
  });
  observer.observe(modalEl, { attributes: true, attributeFilter: ['class'] });
});
